import {
  ApolloClient,
} from "@apollo/client/core";

import v2ClientOptions from "./client-options/v2";
import cmsClientOptions from "./client-options/cms";

const apolloClients = {
  default: new ApolloClient(v2ClientOptions),
  cms: new ApolloClient(cmsClientOptions),
};

export default apolloClients;
